import { Alert, Button, Divider, Space, Tag } from 'antd';
import gql from 'graphql-tag';
import { Link, useHistory } from 'react-router-dom';
import { useAuthedMutationWithNotification, useAuthedQuery } from 'utils/qlAuth';
import { ColoredTags } from './ColoredTags';

export default function Dashboard() {
  const history = useHistory();
  const [StoryController_createStory, StoryController_createStoryRes] = useAuthedMutationWithNotification(gql`
    mutation StoryController_createStory($title: String!) {
      StoryController_createStory(title: $title) {
        id
      }
    }
  `);

  const qStoryList = useAuthedQuery(
    gql`
      query StoryController_getStoryList {
        StoryController_getStoryList {
          id
          title
          initMessage
          status
          ttsText
          fraimsCount
          tags
        }
      }
    `,
  );

  if (StoryController_createStoryRes?.data?.StoryController_createStory?.id) {
    history.push(`/story/${StoryController_createStoryRes.data?.StoryController_createStory.id}/`);
  }

  const stories = qStoryList.data?.StoryController_getStoryList || [];

  return (
    <>
      <Button
        onClick={async () => {
          await StoryController_createStory({ variables: { title: `New story` } });
        }}
      >
        Create Story
      </Button>
      <Divider />
      <Space direction="vertical" style={{ width: '100%' }}>
        {stories.map(story => (
          <Alert
            message={
              <Space direction="horizontal">
                <Tag>{story.id}</Tag>
                <Link to={`/story/${story.id}/`}>
                  <b>{story.title}</b>
                </Link>

                <ColoredTags tags={story.tags} />
              </Space>
            }
          />
        ))}
      </Space>
    </>
  );
}
